module.exports = __webpack_public_path__ + "static/media/tfs.091f74a7.png";